module.exports = __webpack_public_path__ + "static/media/procast_happy_people.bb3562d9.jpg";